import { useEffect, useRef } from 'react';
import { useAuth } from '@y-sports/shared/auth';
import { useClaimPlayerProfileInvitationsMutation } from '../../hooks/useAdminManagementData';
import { useClaimLeagueMemberInvitationsMutation } from '../../hooks/useLeagueData';
import { useClaimTrainingPlayerInvitationsMutation } from '../../hooks/useTrainingData';

export function useInvitationClaims() {
  const { user } = useAuth();
  const { mutate: claimPlayerProfileInvitations } = useClaimPlayerProfileInvitationsMutation();
  const { mutate: claimTrainingPlayerInvitations } = useClaimTrainingPlayerInvitationsMutation();
  const { mutate: claimLeagueMemberInvitations } = useClaimLeagueMemberInvitationsMutation();
  const claimedInvitationEmailRef = useRef<string | null>(null);

  useEffect(() => {
    const email = user?.email?.trim();
    if (!email || claimedInvitationEmailRef.current === email) {
      return;
    }

    claimedInvitationEmailRef.current = email;
    claimPlayerProfileInvitations(email);
    claimTrainingPlayerInvitations(email);
    claimLeagueMemberInvitations(email);
  }, [
    claimLeagueMemberInvitations,
    claimPlayerProfileInvitations,
    claimTrainingPlayerInvitations,
    user?.email,
  ]);
}

